import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Removes tile layers on unmount to prevent async callbacks
// (e.g. _setupAttribution, getPane) from accessing a destroyed map instance.
// Currently targets GoogleMutant layers (identified by the `_mutant` marker).
const MapLayerCleanup = () => {
  const map = useMap();

  useEffect(() => {
    return () => {
      try {
        map.eachLayer((layer) => {
          if ((layer as any)._mutant !== undefined) {
            map.removeLayer(layer);
          }
        });
      } catch {
        // ignore cleanup errors
      }
    };
  }, [map]);

  return null;
};

export default MapLayerCleanup;
